import { createSlice } from "@reduxjs/toolkit";
import ClaimLeaveData from "../models/ClaimLeaveData";
import { normalizeDateOfBirth } from "../utils/helpers";

const transformOdsEmployeeToClaimLeaveData = (rawEmployee) => {
    if (!rawEmployee) return null;

    const dateOfBirth =
        rawEmployee.dateOfBirth ||
        rawEmployee.DateOfBirth ||
        rawEmployee.leave?.employeeDetails?.dateOfBirth ||
        rawEmployee.employeeDetails?.dateOfBirth ||
        null;

    const EmployeeDetails = {
        SSN: rawEmployee.taxIdentificationNumber || null,
        FirstName: rawEmployee.firstName || "",
        LastName: rawEmployee.lastName || "",
        DateOfBirth: normalizeDateOfBirth(dateOfBirth),
        EmployeeID: rawEmployee.employeeId || null,
    };

    const claimLeaveData = ClaimLeaveData.formatOds(rawEmployee);

    return { EmployeeDetails, ClaimLeaveData: claimLeaveData };
};

const mergeOdsEmployees = (rawEmployees) => {
    if (rawEmployees.length <= 1) return rawEmployees[0] ?? null;

    return {
        ...rawEmployees[0],
        claim: rawEmployees.flatMap((emp) => emp.claim || []),
        leave: rawEmployees.flatMap((emp) => emp.leave || []),
    };
};

const employeeClaimLeaveSlice = createSlice({
    name: "employeeClaimLeave",
    initialState: {
        odsEmployeesData: {},
        odsLeaveDetailsData: {},
        odsClaimDetailsData: {},
        selectedOdsEmployeeId: null,
        selectedOdsEmployee: null,
    },
    reducers: {
        setSelectedOrgainzationsIdForReports(state, action) {
            state.selectedOrganizationsIdReports = action.payload;
        },

        setOdsEmployeesData(state, action) {
            state.odsEmployeesData = {
                ...state.odsEmployeesData,
                ...action.payload,
            };
        },

        setOdsLeaveDetailsData(state, action) {
            state.odsLeaveDetailsData = {
                ...state.odsLeaveDetailsData,
                ...action.payload,
            };
        },

        setOdsClaimDetailsData(state, action) {
            state.odsClaimDetailsData = {
                ...state.odsClaimDetailsData,
                ...action.payload,
            };
        },

        // Accepts one cache key or an array of keys whose records are merged.
        setSelectedOdsEmployeeId(state, action) {
            const keys = [].concat(action.payload ?? []);
            const rawEmployees = keys
                .map((key) => state.odsEmployeesData[key])
                .filter(Boolean);

            state.selectedOdsEmployeeId = keys[0] ?? null;
            state.selectedOdsEmployee =
                transformOdsEmployeeToClaimLeaveData(
                    mergeOdsEmployees(rawEmployees)
                ) ?? null;
        },
    },
});

export const {
    setSelectedOrgainzationsIdForReports,
    setOdsEmployeesData,
    setOdsLeaveDetailsData,
    setOdsClaimDetailsData,
    setSelectedOdsEmployeeId,
} = employeeClaimLeaveSlice.actions;

export default employeeClaimLeaveSlice.reducer;
